import { render, staticRenderFns } from "./PriceFilterInput.vue?vue&type=template&id=0d6a0cb1&"
import script from "./PriceFilterInput.vue?vue&type=script&lang=js&"
export * from "./PriceFilterInput.vue?vue&type=script&lang=js&"
import style0 from "./PriceFilterInput.vue?vue&type=style&index=0&id=0d6a0cb1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports